import axios from 'axios';

export const getClientIP = async() => {
    return await axios.get('https://api.ipify.org?format=json')
}